import { AuthContext, AuthProvider } from "./auth.provider";

export const Auth = {
    Provider: AuthProvider,
    Context: AuthContext,
};
